import { AppEnvType, getAppEnv, getAppName, getEnvName } from './env.config';

const appName = getAppName(SUP_APP || 'admin');
const envName = getEnvName(SUP_ENV || 'dev');

export const EnvPlatform = `PC-${`${appName.trim()}`.trim().toUpperCase()}`;
export const EnvVersion = `V1.0.0-${envName}`;

const ENVS: AppEnvType = getAppEnv(appName, envName);

export default ENVS;
